import React,{useMemo,useEffect} from 'react';
import Sidebar from "./Sidebar";
import MaterialReactTable from 'material-react-table';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
// import { clearErrors, getAdminCategories, deleteCategory } from "../../actions/categoryAction";
import { clearErrors, getlogobyadmin, deletelogo } from "../../actions/userAction";
import Loader from "../Loader";
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MetaData from '../../components/MetaData.js';
import { DELETE_LOGO_RESET } from "../../constants/userConstant";

const LogoList = () => {

	const dispatch = useDispatch();
	// const {id} = useParams();
	const alert = useAlert();
	const navigate = useNavigate();
	const { logos, loading, error } = useSelector((state) => state.logos);

	const { error: deleteError, isDeleted } = useSelector((state) => state.logo);

	const deleteLogoHandler = (id) => {
		// console.log('ok');
	    dispatch(deletelogo(id));
	};

	useEffect(() => {
		if (error) {
		  alert.error(error);
		  dispatch(clearErrors());
		}

		if (deleteError) {
		  alert.error(deleteError);
		  dispatch(clearErrors());
		}

		if (isDeleted) {
		  alert.success("Logo Deleted Successfully");
		  // navigate("/admin/dashboard");
		  dispatch({ type: DELETE_LOGO_RESET });
		}

		dispatch(getlogobyadmin());
	}, [dispatch, alert, error, deleteError, isDeleted, navigate]);

	const columns = useMemo(
	    () => [
	      
	      {
	        accessorFn: (row) => row.name, //alternate way
	        id: 'name', //id required if you use accessorFn instead of accessorKey
	        header: 'Name',
	        Header: () => <span>Name</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => <img src={row.images[0]?.url} width="100" height="100" alt={row.name}/>, //alternate way
	        id: 'image', //id required if you use accessorFn instead of accessorKey
	        header: 'Image',
	        Header: () => <span>Logo</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => row.status, //alternate way
	        id: 'status', //id required if you use accessorFn instead of accessorKey
	        header: 'Status',
	        Header: () => <span>Status</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => <span>
	                            <Link to={`/admin/update-logo/${row._id}`}>
	                              <EditIcon />
	                            </Link>
	                            {/*<Button onClick={() => deleteLogoHandler(row._id)}>
	                              <DeleteIcon />
	                            </Button>*/}
	                          </span>, //alternate way
	        id: 'action', //id required if you use accessorFn instead of accessorKey
	        header: 'Action',
	        Header: () => <span>Action</span>, //optional custom header render
	      },
	    ],
	    [],
	);

	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`ALL LOGOS - Admin`} />
						<div className="row">
							<Sidebar />	
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>All Logos</h3>
							        <div className="col-12">
		                    			<MaterialReactTable columns={columns} data={logos} enableRowNumbers rowNumberMode="original"/>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default LogoList